/** @jsx jsx */
import SanityMuxPlayer from 'components/sanity/SanityMuxPlayer'
import { useState } from 'react'
// import SanityMuxPlayer from 'sanity-mux-player'
import { jsx, Box } from 'theme-ui'

const MuxVideo = ({ assetDocument, colorVideo }) => {
  const [videoPlaying, setVideoPlaying] = useState(false)
  return (
    <Box
      sx={{
        position: 'relative',
        pt: ['75%', null, '56.25%'],
        opacity: videoPlaying ? 1 : 0,
        transition: 'opacity 1000ms ease',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          display: 'block',
          width: '100%',
          minWidth: '100%',
          lineHeight: '0px',
          fontSize: '0px',
          transition: 'visibility 1000ms, opacity 1000ms',
          backgroundColor: colorVideo ? 'none' : 'red',
          '::before': {
            position: 'absolute',
            content: '""',
            display: 'block',
            width: 5,
            left: '-5px',
            height: '100%',
            zIndex: 999,
            backgroundColor: 'black',
          },
          '::after': {
            position: 'absolute',
            content: '""',
            display: 'block',
            width: 5,
            right: '-5px',
            top: 0,
            height: '100%',
            zIndex: 999,
            backgroundColor: 'black',
          },
        }}
      >
        <Box
          sx={{
            width: '100%',
            background: 'url(/noise.gif)',
            backgroundPosition: 'center center',
            mixBlendMode: 'multiply',
            opacity: 0.6,
          }}
        />
        <Box
          sx={{
            position: 'relative',
            top: 0,
            left: 0,
            width: 'calc(100% + 2px)',
            left: '-1px',
            mixBlendMode: colorVideo ? 'none' : 'multiply',
            filter: 'brightness(1.12) contrast(1.05)',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'url(/noise.gif)',
              backgroundPosition: 'center center',
              mixBlendMode: 'multiply',
              opacity: 0.6,
            }}
          />
          <SanityMuxPlayer
            assetDocument={assetDocument}
            autoload={true}
            autoplay={true}
            showControls={false}
            muted={true}
            loop={true}
            playsInline={true}
            onPlay={() => setVideoPlaying(true)}
          />
        </Box>
      </Box>
    </Box>
  )
}

export { MuxVideo }
